import React from "react";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Typography,
} from "@mui/material";

// Devuelve el primer y ultimo dia del mes en curso en formato YYYY-MM-DD.
export const mesActual = () => {
  const hoy = new Date();
  const primero = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
  const ultimo = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
  return { fecha_inicio: iso(primero), fecha_fin: iso(ultimo) };
};

const iso = (fecha) =>
  `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(fecha.getDate()).padStart(2, "0")}`;

// Alterna entre "Mes actual" y un rango libre. Al cambiar de modo o de fecha
// dispara onChange con el rango nuevo, que es lo que re-consulta el dashboard.
const DateRangeFilter = ({ modo, rango, onChange }) => {
  const cambiarModo = (_event, nuevoModo) => {
    if (!nuevoModo) return;
    onChange(
      nuevoModo,
      nuevoModo === "mes" ? mesActual() : { ...rango }
    );
  };

  const cambiarFecha = (campo) => (event) => {
    onChange("rango", { ...rango, [campo]: event.target.value });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      <ToggleButtonGroup
        value={modo}
        exclusive
        onChange={cambiarModo}
        size="small"
      >
        <ToggleButton value="mes" sx={{ px: 2 }}>
          Mes actual
        </ToggleButton>
        <ToggleButton value="rango" sx={{ px: 2 }}>
          Rango de fechas
        </ToggleButton>
      </ToggleButtonGroup>

      {modo === "rango" ? (
        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
          <TextField
            type="date"
            size="small"
            label="Desde"
            value={rango.fecha_inicio}
            onChange={cambiarFecha("fecha_inicio")}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            type="date"
            size="small"
            label="Hasta"
            value={rango.fecha_fin}
            onChange={cambiarFecha("fecha_fin")}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
      ) : (
        <Typography sx={{ fontSize: 12.5, color: "text.secondary" }}>
          {rango.fecha_inicio} al {rango.fecha_fin}
        </Typography>
      )}
    </Box>
  );
};

export default DateRangeFilter;
